import type { ControlFieldAlignType, ElementWithOptionalLabelType } from '../../../types'

interface CheckboxBaseProp {
  align?: ControlFieldAlignType
  checked?: boolean
  className?: string
  disabled?: boolean
  error?: boolean
  onChange?: (value: boolean | CheckboxStateType) => void
  state?: CheckboxStateType
}

export enum CheckboxState {
  checked = 'checked',
  indeterminate = 'indeterminate',
  unchecked = 'unchecked',
}

export type CheckboxProp = ElementWithOptionalLabelType<CheckboxBaseProp>
export type CheckboxStateType = `${CheckboxState}`
